var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66797C17.1269 1.66797 17.5 2.04107 17.5 2.5013V5.63214L15.8333 7.2988V3.33464H4.16667V16.668H15.8333V14.3696L17.5 12.703V17.5013C17.5 17.9616 17.1269 18.3346 16.6667 18.3346H3.33333C2.8731 18.3346 2.5 17.9616 2.5 17.5013V2.5013C2.5 2.04107 2.8731 1.66797 3.33333 1.66797H16.6667ZM18.1485 7.34098L19.327 8.51947L12.8452 15.0013L11.6649 14.9996L11.6667 13.8228L18.1485 7.34098ZM10.8333 10.0013V11.668H6.66667V10.0013H10.8333ZM13.3333 6.66797V8.33464H6.66667V6.66797H13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftLine);
export default __webpack_public_path__ + "static/media/draft-line.fb6ef7583fbb1246ba2a18204c686c23.svg";
export { ForwardRef as ReactComponent };